import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import staticQueryData from "../../public/static/d/3941510517.json";
import React from 'react';
import { StaticQuery, navigate } from 'gatsby';
import SearchList from '../components/SearchList';
var KEY_CODE_ENTER = 13;
var KEY_CODE_UP = 38;
var KEY_CODE_DOWN = 40;
var SEARCH_BAR_CLASSNAME = 'search-container';

var hasClass = function hasClass(element, className) {
  var elClassName = element && element.getAttribute && (element.getAttribute('class') || element.getAttribute('className') || '');
  return elClassName.indexOf(className) > -1;
};

var toLowerCase = function toLowerCase(str) {
  return str.toLowerCase();
};

var defaultState = {
  searching: false,
  value: null,
  movedIndex: -1,
  result: []
};

var SearchBar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SearchBar, _React$Component);

  function SearchBar() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = defaultState;
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = SearchBar.prototype;

  _proto.attachEvent = function attachEvent() {
    document.addEventListener('click', this.handleClick);
  };

  _proto.detachEvent = function detachEvent() {
    document.removeEventListener('click', this.handleClick);
  };

  _proto.handleKeyDown = function handleKeyDown(ev) {
    var _this2 = this;

    var keyCode = ev.keyCode;
    this.setState(function (prevState) {
      var index = prevState.movedIndex;

      if (keyCode === KEY_CODE_UP && index > 0) {
        index -= 1;
      } else if (keyCode === KEY_CODE_DOWN && index < _this2.state.result.length - 1) {
        index += 1;
      }

      return {
        movedIndex: index
      };
    });
  };

  _proto.handleKeyUp = function handleKeyUp(ev) {
    var keyCode = ev.keyCode,
        target = ev.target;
    var _this$state = this.state,
        result = _this$state.result,
        movedIndex = _this$state.movedIndex;

    if (keyCode === KEY_CODE_UP || keyCode === KEY_CODE_DOWN) {
      return;
    }

    if (keyCode === KEY_CODE_ENTER && result.length && movedIndex > -1) {
      var url = "/" + result[movedIndex].node.pid;
      this.moveToPage(url);
    } else {
      this.search(target.value);
    }
  };

  _proto.handleFocus = function handleFocus(ev) {
    var value = ev.target.value;
    this.attachEvent();

    if (value.length) {
      this.search(value);
    }
  };

  _proto.handleClick = function handleClick(ev) {
    var element = ev.target;

    while (element && !hasClass(element, SEARCH_BAR_CLASSNAME)) {
      element = element.parentElement;
    }

    if (!element) {
      this.resetState();
    }
  };

  _proto.search = function search(query) {
    this.setState({
      searching: true,
      value: query,
      result: this.findMatchingValues(query)
    });
  };

  _proto.findMatchingValues = function findMatchingValues(value) {
    return this.props.data.filter(function (item) {
      var foundValue = toLowerCase(item.node.name);
      return value !== '' && foundValue.indexOf(toLowerCase(value)) > -1;
    });
  };

  _proto.moveToPage = function moveToPage(url) {
    if (url) {
      navigate(url);
    }

    this.resetState();
  };

  _proto.resetState = function resetState() {
    this.detachEvent();
    this.setState({
      searching: false,
      value: null,
      result: [],
      movedIndex: -1
    });
  };

  _proto.render = function render() {
    var _this$state2 = this.state,
        searching = _this$state2.searching,
        value = _this$state2.value,
        result = _this$state2.result,
        movedIndex = _this$state2.movedIndex;
    return React.createElement("div", {
      className: "search-container" + (searching ? ' searching' : '')
    }, React.createElement("div", {
      className: "search-box"
    }, React.createElement("span", {
      className: "btn-search" + (searching ? ' searching' : '')
    }, React.createElement("span", {
      className: "icon"
    }, React.createElement("span", {
      className: "oval"
    }), React.createElement("span", {
      className: "stick"
    }))), React.createElement("input", {
      type: "text",
      placeholder: "Search",
      onKeyDown: this.handleKeyDown,
      onKeyUp: this.handleKeyUp,
      onFocus: this.handleFocus
    })), React.createElement("hr", {
      className: "line " + (searching ? 'show' : 'hide')
    }), React.createElement(SearchList, {
      searching: searching,
      value: value,
      result: result,
      movedIndex: movedIndex
    }));
  };

  return SearchBar;
}(React.Component);

var SearchBarWrapper = function SearchBarWrapper() {
  return React.createElement(StaticQuery, {
    query: "3941510517",
    render: function render(data) {
      return React.createElement(SearchBar, {
        data: data.allSearchKeywordsJson.edges
      });
    },
    data: staticQueryData
  });
};

export default SearchBarWrapper;